import { Typography } from "@mui/material";
import type { FC } from "react";
import { INK } from "../../../theme/tokens";
import { type SelfScheduleCalendarDayData, SelfSchedulingPreference } from "../../../utils/models";

export const SubText: FC<{ dayData: SelfScheduleCalendarDayData }> = ({ dayData }) => {
	let text: string = "";

	if (dayData.dayPreference === SelfSchedulingPreference.WANT_TO_WORK && dayData.startTime && dayData.endTime) {
		text = `${dayData.startTime.toFormat("ha")}-${dayData.endTime.toFormat("ha")}`;
	}

	return (
		text && (
			<Typography sx={{ mt: 0.5, fontWeight: 600, fontSize: "8px", lineHeight: "100%", color: INK.SECONDARY, userSelect: "none", width: "100%" }}>
				{text}
			</Typography>
		)
	);
};
